import styled, { css } from 'styled-components';

const TableContainer = styled.div`
  overflow: auto;
  max-height: 600px;
  display: block;
`;

const Table = styled.table`
  display: table;
  border-spacing: 0;
  border-collapse: collapse;
  font-size: 12px;
  width: 100%;
`;

const TableHeadCell = styled.th`
  padding: 6px 16px;
  text-align: ${props => props.align || 'center'};
  vertical-align: inherit;
  font-weight: ${props => props.weight};
  font-size: ${props => props.fontSize}px;

  ${props =>
    props.clickable &&
    `
    cursor: pointer;
  `};
`;

const TableHead = styled.thead`
  background-color: ${props => props.theme.colors.grey};
  border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
  font-weight: 600;
`;

const TableRow = styled.tr`
  color: inherit;
  height: 48px;
  display: table-row;
  outline: none;
  vertical-align: middle;
  position: relative;
  border-bottom: 1px solid rgba(224, 224, 224, 1);

  &:last-child {
    border-bottom: none;
  }

  ${props => props.clickable && 'cursor: pointer;'};

  ${props => props.inactive && 'background: rgba(255, 0, 0, 0.4);'};

  ${props => props.hover && '&:hover {background: rgba(224, 224, 224, 0.5);}'};

  ${props => props.selected && 'background: rgba(32,131,254, 0.5);'};

  ${props => props.danger && 'background: rgba(255, 0, 0, 0.4);'};

  ${props => props.warning && 'background: rgb(232,219,125, 0.4);'};

  ${props => props.success && 'background: rgba(87,167,115, 0.4);'};

  ${props => props.pending && 'background: rgba(224, 224, 224, 0.5);'};
`;

const TableCell = styled.td`
  display: table-cell;
  padding: 6px 16px;
  min-width: 100px;
  text-align: ${props => props.align || 'center'};
  vertical-align: inherit;
  font-weight: ${props => props.weight};
  font-size: ${props => props.fontSize || '14'}px;

  ${props => props.lineHeight && `line-height: ${props.lineHeight};`}

  ${props => props.clickable && 'cursor: pointer;'};

  ${props => props.justify && ` display: flex; justify-content: ${props.justify};`};

  ${props =>
    props.header &&
    `
    background-color: ${props.theme.colors.grey};
    border-bottom: 1px solid #ffffff;
  `}

  ${({ color, theme }) => color && css`
    color: ${theme.colors[color]};
  `};

  ${({ backgroundColor, theme }) => backgroundColor && css`
    background-color: ${theme.colors[backgroundColor]};
  `};
`;

const TableBody = styled.tbody`
  width: 100%;
`;

export { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TableHeadCell };
